import * as React from 'react';

import { useDesignSystemFlags } from '../../../Hooks';
import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';

function SvgSearch1IconV1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.618 17.032a9 9 0 111.414-1.414l5.675 5.675-1.414 1.414-5.675-5.675zM17 10a7 7 0 11-14 0 7 7 0 0114 0z"
        fill="currentColor"
      />
    </svg>
  );
}

function SvgSearch1IconV2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#SearchIcon_svg__clip0_13123_34883)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 1a7 7 0 104.39 12.453l2.55 2.55 1.06-1.06-2.55-2.55A7 7 0 008 1zM2.5 8a5.5 5.5 0 1111 0 5.5 5.5 0 01-11 0z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="SearchIcon_svg__clip0_13123_34883">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function Search1Icon(props: IconProps) {
  const { USE_NEW_ICONS } = useDesignSystemFlags();
  const component = USE_NEW_ICONS ? SvgSearch1IconV2 : SvgSearch1IconV1;
  return <Icon {...props} component={component} />;
}

export default Search1Icon;
